import { PlayCircle, Clock, Route, Wrench, Users } from "lucide-react";

const summaryItems = [
  {
    icon: PlayCircle,
    title: "Clases grabadas como base",
    description: "Contenido disponible 24/7 para avanzar a tu ritmo",
  },
  {
    icon: Clock,
    title: "Acceso por tiempo",
    description: "90, 180 o 360 días según la modalidad elegida",
  },
  {
    icon: Route,
    title: "Ruta práctica",
    description: "Estructura organizada para desarrollar criterio",
  },
  {
    icon: Wrench,
    title: "Herramientas complementarias",
    description: "Recursos de apoyo para validación y operación",
  },
  {
    icon: Users,
    title: "Comunidad y acompañamiento",
    description: "Entorno de aprendizaje con continuidad",
  },
];

export default function QuickSummarySection() {
  return (
    <section
      data-testid="quick-summary-section"
      className="py-16 md:py-20 bg-white border-b border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.25em] font-semibold text-[#0F3D56] mb-3">
            Resumen de la propuesta
          </p>
          <h2
            className="text-2xl md:text-3xl font-semibold text-[#111827]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Lo que incluye esta ruta educativa
          </h2>
        </div>

        {/* Summary Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4">
          {summaryItems.map((item, index) => (
            <div
              key={index}
              data-testid={`summary-item-${index}`}
              className="group text-center p-6 bg-gray-50/50 hover:bg-[#0F3D56]/5 border border-gray-100 hover:border-[#0F3D56]/20 transition-all duration-300"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 mb-4 bg-[#0F3D56]/10 group-hover:bg-[#0F3D56]/15 transition-colors">
                <item.icon size={24} className="text-[#0F3D56]" />
              </div>
              <h3 className="text-sm font-bold text-[#111827] mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
